import { createSlice } from '@reduxjs/toolkit';
import { ServicesSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { SortTypes } from 'src/screens/services/ServicesScreen.types';

import { ServicesInitialStateType } from '../types/servicesTypes';
const name = 'services';

const INITIAL_TYPE: ServicesInitialStateType = {
  services: [],
  filteredServices: [],
  isServicesLoading: false,
  isFilteredServicesLoading: false,
  selectedToggleBoxValue: ServicesSearchTypes.SERVICE,
  sortByValue: SortTypes.NAME,
  searchInputValue: '',
  searchParams: null,
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
};

const servicesSlice = createSlice({
  name,
  initialState: INITIAL_TYPE,
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput, sortBy } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
      state.sortByValue = sortBy;
    },

    getServices: state => {
      state.isServicesLoading = true;
    },
    getServicesSuccess: (state, action) => {
      state.isServicesLoading = false;
      state.services = action.payload;
    },
    getServicesFailure: (state, action) => {
      state.isServicesLoading = false;
      state.error = action.payload;
    },

    getFilteredServices: (state, action) => {
      state.isFilteredServicesLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredServicesSuccess: (state, action) => {
      state.isFilteredServicesLoading = false;
      state.filteredServices = action.payload;
    },
    getFilteredServicesFailure: (state, action) => {
      state.isFilteredServicesLoading = false;
      state.error = action.payload;
    },

    createServices: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createServicesSuccess: state => {
      state.isCreateRequestLoading = false;
    },
    createServicesFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateServices: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateServicesSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateServicesFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeServices: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeServicesSuccess: state => {
      state.isRemoveRequestLoading = false;
    },
    removeServicesFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getServices,
  getServicesFailure,
  getServicesSuccess,

  getFilteredServices,
  getFilteredServicesSuccess,
  getFilteredServicesFailure,

  createServices,
  createServicesFailure,
  createServicesSuccess,

  updateServices,
  updateServicesFailure,
  updateServicesSuccess,

  removeServices,
  removeServicesFailure,
  removeServicesSuccess,
} = servicesSlice.actions;

export default servicesSlice.reducer;
